//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/TaggedObject.js";
let d=[[[0,"GeometryAxisX",1,0],[0,"GeometryAxisY",1,0],[0,"GeometryAxisZ",1,0],[0,"MainSpindle",1,0],[0,"Name",1,0]],[[["numAssignedAxes","assignedAxes"],"GetAssignedAxes",{},0,0],[["assignedAxes"],"SetAssignedAxes",{},1,0],[["axisName"],"SetAssignedAxis",{},1,0],[["axisName"],"SetUnassignedAxis",{},1,0],[["numRefSpindles","refSpindles"],"GetReferencedSpindles",{},0,0],[["refSpindles"],"SetReferencedSpindles",{},1,0],[["spindleName"],"SetReferencedSpindle",{},1,0],[["spindleName"],"SetUnreferencedSpindle",{},1,0],[["deviceName"],"SetReferencedDevice",{},1,0],[["deviceName"],"SetUnreferencedDevice",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.SIM.KinematicChannelBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.KinematicChannelBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;